import { combineReducers } from 'redux';
import userReducer from './userSlice';
import clients from './clients';
import clientData from './clientData';
import photosFromDevice from './photosFromDevice';
import drafts from './drafts';
import app from './app';
import clientUI from './clientUI';
import help from './helpSlice';
import video from './video';

export default combineReducers({
  app,
  user: userReducer,
  clients,
  clientData,
  photosFromDevice,
  drafts,
  clientUI,
  help,
  video,
});
